import { render, staticRenderFns } from "./ddqr.vue?vue&type=template&id=15638b89&scoped=true&"
import script from "./ddqr.vue?vue&type=script&lang=js&"
export * from "./ddqr.vue?vue&type=script&lang=js&"
import style0 from "./ddqr.vue?vue&type=style&index=0&id=15638b89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15638b89",
  null
  
)

export default component.exports